import * as React from "react";
import { Modal, ModalSize, ModalBody, ModalFooter, Form, Checkbox, AlertMessage, AlertType, CustomButton, ButtonType, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { ListingsApi } from "../../../api/ListingsApi";

interface IListPatientForm {
    patientId: number;
    onPatientListed: () => any;
}

export const ListPatientForm: React.FunctionComponent<IListPatientForm> = ({ patientId, onPatientListed }) => {
    const auth = useAuth();
    const api = new ListingsApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isFormLoading, setIsFormLoading] = React.useState<boolean>(false);

    const onSubmit = () => {
        setIsFormLoading(true);
        api.listPatient(patientId, () => {
            document.getElementById("close-list-patient-modal")?.click();
            onPatientListed();
        }, (errorMessage: string) => {
            setIsFormLoading(false);
            setErrorMessage(errorMessage);
        })
    }

    return (
        <Modal header="Lista patient" id="list-patient-modal" preventCloseOnOutsideClick={false} modalSize={ModalSize.normal}>
            <Form onSubmit={onSubmit}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000} >{errorMessage}</AlertMessage>
                    <p>För att lista den här patienten på din mottagning krävs det en överenskommelse om vårdansvar mellan vårdgivaren och patienten.</p>
                    <Checkbox value="agreement" label="Jag bekräftar att en överenskommelse finns" name="agreement" id="agreement" required labelCol={9} inputCol={3} />
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} data-dismiss="modal" buttonText="Avbryt" id="close-list-patient-modal"/>
                        <CustomSubmitButton isLoading={isFormLoading}>Lista patienten</CustomSubmitButton>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    )
}